import { useMemo } from 'react';

import { useQueryParamValue } from '#src/app/shared/hooks/location';
import type { SignPetitionHookInput } from '#src/app/shared/hooks/signature';

type Result = Pick<
	SignPetitionHookInput,
	'sourceLocation' | 'algorithm' | 'inviteRecruiterUuid' | 'inviteRecruiterId' | 'inviteRequestedAt'
>;

export function useQuerySignData(): Result {
	const sourceLocation = useQueryParamValue('source_location') || null;
	const algorithm = useQueryParamValue('algorithm') || null;
	const inviteRecruiterUuid = useQueryParamValue('recruited_by_uuid') || null;

	return useMemo(
		() => ({
			sourceLocation,
			algorithm,
			inviteRecruiterUuid,
			inviteRecruiterId: null, // was not sent by fe
			inviteRequestedAt: null, // was not sent by fe
		}),
		[sourceLocation, algorithm, inviteRecruiterUuid],
	);
}
